// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1076":"1053ed1cfd5436ba","4028":"4dfa2e3f2030ae9f"}[chunkId] + ".css";
};